/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/capital_2': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27.75 12.336V4.25h-8.086L16 .586 12.336 4.25H4.25v8.086L.586 16l3.664 3.664v8.086h8.086L16 31.414l3.664-3.664h8.086v-8.086L31.414 16l-3.664-3.664zm-23-7.586h7.086L4.75 11.836V4.75zm0 22.5v-7.086l7.086 7.086H4.75zm12.75-3h-3v-.75h3v.75zm1.346-2.689l-.596 1.189h-.75V19h-.75v.75h-1.5V19h-.75v3.75h-.75l-.595-1.189-3.118.623-.074-.367L13 21.209V11.5l-.75.75v8.25l-3.613.723-.092-.092 2.133-5.688-2.311-2.31.266-.266 2.189 2.19L13 9.25v2.25l.75-.75v-3h.75v9.75h.75v-3l.375-.75v-3h.75v3l.375.75v3h.75V7.75h.75v3l.75.75V9.25l2.178 5.808 2.189-2.19.266.266-2.311 2.31 2.133 5.688-.092.093-3.613-.725v-8.25L19 11.5v9.709l3.037.607-.074.367-3.117-.622zm8.404 5.689h-7.086l7.086-7.086v7.086zm0-15.414L20.164 4.75h7.086v7.086z"/>'
  }
})
